/**
 * Collection template: hide/show filters, optional color swatch hex overrides.
 */
(function () {
    function initFiltersToggle(root) {
      if (!root) return;
      var btn = root.querySelector('[data-sleepys-toggle-filters]');
      if (!btn) return;
  
      var STORAGE_KEY = 'sleepys-collection-filters-visible';
      var hiddenClass = 'sleepys-collection--filters-hidden';
  
      function applyFromStorage() {
        try {
          var v = localStorage.getItem(STORAGE_KEY);
          if (v === '0') root.classList.add(hiddenClass);
          else root.classList.remove(hiddenClass);
          syncLabel();
        } catch (e) {
          /* ignore */
        }
      }
  
      function syncLabel() {
        var hidden = root.classList.contains(hiddenClass);
        var showText = btn.getAttribute('data-label-show-filters') || 'Show filters';
        var hideText = btn.getAttribute('data-label-hide-filters') || 'Hide filters';
        var labelEl = btn.querySelector('.sleepys-collection-hide-filters__label');
        if (labelEl) {
          labelEl.textContent = hidden ? showText : hideText;
        } else {
          btn.textContent = hidden ? showText : hideText;
        }
        btn.setAttribute('aria-expanded', hidden ? 'false' : 'true');
      }
  
      btn.addEventListener('click', function () {
        root.classList.toggle(hiddenClass);
        try {
          localStorage.setItem(STORAGE_KEY, root.classList.contains(hiddenClass) ? '0' : '1');
        } catch (e) {
          /* ignore */
        }
        syncLabel();
      });
  
      applyFromStorage();
      syncLabel();
    }
  
    /** Map filter swatch label (lowercase) → hex — extend as needed for your catalog */
    var COLOR_HEX = {
      natural: '#EEE1AE',
      biscuit: '#EEE1AE',
      sand: '#EACFB1',
      peach: '#EACFB1',
      blue: '#91A4C8',
      slate: '#91A4C8',
      denim: '#91A4C8',
      pink: '#FCA4C3',
      rose: '#FCA4C3',
      blush: '#FCA4C3',
      lilac: '#DBB1E5',
      lavender: '#DBB1E5',
      mint: '#9ED9C5',
      sage: '#9ED9C5',
      charcoal: '#443232',
      brown: '#443232',
      espresso: '#443232',
    };
  
    function paintFilterSwatches(root) {
      if (!root) return;
      root.querySelectorAll('.swatch-input__label[title]').forEach(function (label) {
        var t = (label.getAttribute('title') || '').toLowerCase().trim();
        var hex = COLOR_HEX[t];
        if (!hex) return;
        var sw = label.querySelector('.swatch');
        if (!sw) return;
        sw.style.backgroundColor = hex;
        sw.style.backgroundImage = 'none';
      });
    }

    function getMobileFacetsSummary(layout) {
      return layout.querySelector('.mobile-facets__disclosure > summary.mobile-facets__open-wrapper');
    }

    function getMobileFacetsDetails(layout) {
      var s = getMobileFacetsSummary(layout);
      return s && s.closest('details');
    }

    function openMobileFacetsDrawer(layout) {
      var summary = getMobileFacetsSummary(layout);
      var details = getMobileFacetsDetails(layout);
      if (!summary || !details) return;
      if (!details.hasAttribute('open')) {
        summary.click();
      }
    }

    function focusMobileSort(layout) {
      var sortSelect = layout.querySelector('#SortBy-mobile');
      if (!sortSelect) return;
      try {
        sortSelect.focus({ preventScroll: false });
      } catch (e) {
        /* ignore */
      }
      sortSelect.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    function syncMobileToolbarStickyTop() {
      var headerSection = document.querySelector('.section-header');
      var headerHeight = headerSection ? headerSection.offsetHeight : 0;
      if (headerHeight > 0) {
        document.documentElement.style.setProperty('--sleepys-mobile-toolbar-top', headerHeight + 'px');
      }
    }

    function initMobileCollectionFilterBar(layout) {
      var bar = layout.querySelector('[data-sleepys-mobile-collection-toolbar]');
      if (!bar) return;

      var filterBtn = bar.querySelector('[data-open-mobile-facets]');
      var sortBtn = bar.querySelector('[data-open-mobile-facets-sort]');

      if (filterBtn && filterBtn.dataset.sleepysBound !== '1') {
        filterBtn.dataset.sleepysBound = '1';
        filterBtn.addEventListener('click', function () {
          openMobileFacetsDrawer(layout);
        });
      }

      if (sortBtn && sortBtn.dataset.sleepysBound !== '1') {
        sortBtn.dataset.sleepysBound = '1';
        sortBtn.addEventListener('click', function () {
          var details = getMobileFacetsDetails(layout);
          var wasOpen = details && details.hasAttribute('open');
          openMobileFacetsDrawer(layout);
          var delay = wasOpen ? 0 : 320;
          window.setTimeout(function () {
            focusMobileSort(layout);
          }, delay);
        });
      }
    }
  
    var syncStickyTopRaf = 0;
    function scheduleMobileToolbarStickyTopSync() {
      if (syncStickyTopRaf) return;
      syncStickyTopRaf = window.requestAnimationFrame(function () {
        syncStickyTopRaf = 0;
        syncMobileToolbarStickyTop();
      });
    }

    window.addEventListener('resize', scheduleMobileToolbarStickyTopSync);
    document.addEventListener('shopify:section:load', scheduleMobileToolbarStickyTopSync);

    document.addEventListener('DOMContentLoaded', function () {
      syncMobileToolbarStickyTop();
      document.querySelectorAll('.sleepys-collection-layout').forEach(function (root) {
        initFiltersToggle(root);
        paintFilterSwatches(root);
        initMobileCollectionFilterBar(root);
      });
    });
  
    document.addEventListener('shopify:section:load', function (ev) {
      var root = ev.target && ev.target.querySelector && ev.target.querySelector('.sleepys-collection-layout');
      if (root) {
        initFiltersToggle(root);
        paintFilterSwatches(root);
        initMobileCollectionFilterBar(root);
      }
    });
  })();
  